import React, { useEffect } from "react";
import moment from 'moment';
import Loader from '../../elements/Loader';
import { Button, List } from "@material-ui/core";
import CourseCard from "../../elements/CourseCard";
import LessonLine from "../../elements/Lesson/LessonLine";
import LessonBackground from "../../elements/Lesson/LessonBackground";
import breakpoint from "../../helpers/breakpoints";

const Lessons = (props) => {

  const { plan, isLoading, fetchLessonsForGroup, group, clearLessons, history, removeLessonById, currentUser } = props;

  useEffect(() => {
    fetchLessonsForGroup(group);
    return () => clearLessons();
    // eslint-disable-next-line 
  }, []);

  return (
    <div>
      {isLoading && <Loader />}
      <div className="role-based-container">
        <div className={breakpoint() === 'XL' ? "two-columns-list" : "one-column-list"}>
          <div className="left-column">
            <div style={breakpoint() === 'XS' ? { width: '270px' } : { width: '350px' }}>
              <Button variant="outlined" className="secondary-button" onClick={() => history.push('/lessons')}>
                Back to all lessons
              </Button>
              {breakpoint() === 'XL' ?
                <CourseCard style={{ marginTop: '72px' }} group={group} />
                :
                null
              }
              {breakpoint() === 'XL' ?
                <LessonBackground group={group} number={plan.length} />
                :
                null
              }
            </div>
          </div>
          {plan.length === 0 ?
            <div className={breakpoint() === 'XS' ? "mt-5 mb-5 empty-lesson-list-xs" : "mt-5 mb-5"}>
              <p>Empty? No worries! You will see lessons here once the course starts.</p>
            </div>
            :
            <div className="right-column">
              <List className={breakpoint() === 'XL' ? 'xl-lesson-list' : 'l-lessons-list'}>
                {
                  plan.map((el, i) => (<LessonLine currentUser={currentUser} lesson={el} index={i} key={i} removeLessonById={removeLessonById} />))
                }
              </List>
            </div>
          }
        </div>
      </div>
    </div>
  );
}

export default Lessons;
